import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[copy-to-clipboard]',
  standalone: true
})
export class CopyToClipboardDirective {
  @Input('copy-to-clipboard') textToCopy: string = '';

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.preventDefault();
    if (this.textToCopy) {
      navigator.clipboard.writeText(this.textToCopy).then(() => {
        const appScope = (window as any).appScope;
        if (appScope) {
          appScope.bJobShareCopied = true;
          // In modern Angular, we don't need $apply, but if legacy code relies on it,
          // we might need to trigger a global detection if such a thing exists.
        }
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    }
  }
}
